
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchContentTypes,
  fetchGroups,
  fetchPermissions,
} from "./thunks";
import { ContentType,Group,Permission } from "./types";

interface RolesAndPermissionsState {
  contentTypes: ContentType[];
  groups: Group[];
  permissions: Permission[];
  loading: boolean;
}

const initialState: RolesAndPermissionsState = {
  contentTypes: [],
  groups: [],
  permissions: [],
  loading: false,
};

const rolesAndPermissionsSlice = createSlice({
  name: "rolesAndPermissions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
     
      .addCase(fetchContentTypes.fulfilled, (state, action) => {
        state.contentTypes = action.payload;
      })
      .addCase(fetchGroups.fulfilled, (state, action) => {
        state.groups = action.payload;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.permissions = action.payload;
      })

      
      .addMatcher(
        (action) => action.type.endsWith("/pending"),
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith("/fulfilled"),
        (state) => {
          state.loading = false;
        }
      );
  },
});


export default rolesAndPermissionsSlice.reducer;
